function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useLayoutEffect, useState } from 'react';
import { ThemeProvider as MUIThemeProvider, useMediaQuery } from '@mui/material';
import themes from "../themes";
import ThemeContext from "../themes/themeContext";
var DEFAULT_THEMES = ['light', 'dark', 'system'];
var CX_THEME_COLORS;
var THEME;
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$colors = _ref.colors,
    colors = _ref$colors === void 0 ? CX_THEME_COLORS : _ref$colors,
    propsMode = _ref.mode,
    _ref$theme = _ref.theme,
    options = _ref$theme === void 0 ? THEME : _ref$theme;
  if (options) THEME = options;
  var _useState = useState(function () {
      if (propsMode) {
        window.localStorage.setItem('themeMode', propsMode);
        return propsMode;
      }
      var storageMode = window.localStorage.getItem('themeMode') || 'system';
      var parseStorageMode = storageMode;
      if (storageMode) {
        try {
          parseStorageMode = JSON.parse(storageMode);
        } catch (error) {}
      }
      if (colors) {
        CX_THEME_COLORS = colors;
        var colorsThemeMode = Object.keys(colors);
        var colorsFirstMode = colorsThemeMode[0];
        if (parseStorageMode && colors.hasOwnProperty(parseStorageMode) || parseStorageMode === 'system' && colors.hasOwnProperty('light') && colors.hasOwnProperty('dark')) {
          return parseStorageMode;
        }
        window.localStorage.setItem('themeMode', colorsFirstMode);
        return colorsFirstMode;
      } else {
        return parseStorageMode && DEFAULT_THEMES.includes(parseStorageMode) ? parseStorageMode : 'system';
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  var prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  var theme = useMemo(function () {
    var newMode = mode;
    if (mode === 'system' && (colors !== null && colors !== void 0 && colors.hasOwnProperty('dark') && colors !== null && colors !== void 0 && colors.hasOwnProperty('light') || colors === void 0)) {
      newMode = prefersDarkMode ? 'dark' : 'light';
    }
    return themes({
      mode: newMode,
      colors: colors,
      theme: options
    });
  }, [mode, prefersDarkMode, colors]);
  var themeMode = useMemo(function () {
    return {
      mode: mode,
      colors: colors,
      setThemeMode: function setThemeMode(mode) {
        setMode(mode);
        window.localStorage.setItem('themeMode', mode);
      }
    };
  }, [mode]);
  useLayoutEffect(function () {
    var bodyStyle = document.body.style;
    var body = document.body;
    var newMode = mode;
    if (mode === 'system' && (colors !== null && colors !== void 0 && colors.hasOwnProperty('dark') && colors !== null && colors !== void 0 && colors.hasOwnProperty('light') || colors === void 0)) {
      newMode = prefersDarkMode ? 'dark' : 'light';
    }
    body.className = newMode;
    // @ts-ignore
    bodyStyle.backgroundColor = theme.palette.background.paper0;
    bodyStyle.color = theme.palette.text.secondary;
  }, [theme]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeMode
  }, /*#__PURE__*/React.createElement(MUIThemeProvider, {
    theme: theme
  }, children));
};
export default ThemeProvider;